<template>
  <div>
    <nav-bar :title="'Rewards banks'"></nav-bar>
    <div class="mobile py-4">
      <reward-skeleton v-if="loading"></reward-skeleton>
      <div
        v-else
        class="atm-desktop-max-width d-flex flex-wrap gap-4 justify-content-center mx-auto"
      >
        <h3 class="font-weight-bold w-100">Bank reward Ideas</h3>
        <div
          class="d-flex flex-wrap gap-4 justify-content-center align-items-stretch w-100 atm-desktop-max-width px-4 py-4 mx-auto"
        >
          <div
            v-if="defaultRewards"
            class="d-flex gap-4 flex-wrap justify-content-center align-items-stretch w-100 mt-4"
          >
            <div
              v-for="(reward, id) in defaultRewards"
              :key="id"
              class="position-relative rewardCard atm-rounded atm-shadow"
              :class="reward.selected ? 'bg-gray' : ''"
              @click="selectReward(reward.id)"
            >
              <reward-card :reward-data="reward" :reward-bank="true" />
            </div>
          </div>
          <div v-else class="d-flex flex-column justify-content-center align-items-center">
            <span
              class="material-icons border-2 full-icon rounded-circle align-middle mt-5 mb-4 border-0"
            >
              card_giftcard
            </span>
            <p class="h4 text-xmuted mx-4">
              There is no banked rewards at the moment.
            </p>
          </div>
        </div>
        <button
          v-if="showSaveButton"
          class="atm-button bg-main mt-2 mb-4 w-50 mx-auto"
          @click="createDefaultRewards"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar } from '@/common/components';
import rewardCard from '../components/RewardCard.vue';
import RewardSkeleton from '../components/skeletons/RewardSkeleton.vue';
import { getDefaultRewards, setCreateReward } from '../services';
import { useSessionStore } from '@/common';

export default {
  data() {
    const sessionStore = useSessionStore();
    return {
      defaultRewards: [],
      showSaveButton: false,
      sessionStore,
      loading: false,
    };
  },
  components: {
    NavBar,
    rewardCard,
    RewardSkeleton,
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    childId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
    rewardsSelected() {
      return this.defaultRewards.filter((reward) => reward.selected);
    },
  },
  async mounted() {
    try {
      this.loading = true;
      this.defaultRewards = await getDefaultRewards();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async selectReward(newRewardId) {
      this.defaultRewards = this.defaultRewards.map((reward) =>
        reward.id === newRewardId ? { ...reward, selected: !reward.selected } : reward,
      );
    },
    async createDefaultRewards() {
      const rewardsDefaultSelected = this.rewardsSelected;
      this.loading = true;
      const payloadRewardsSelected = rewardsDefaultSelected.map((reward) => ({
        prepopulated_id: reward.id,
        name: reward.name,
        child: this.childId,
        coins_required: reward.coins_required,
        re_use: false,
      }));
      try {
        await Promise.all(payloadRewardsSelected.map((reward) => setCreateReward(reward)));
      } catch (error) {
        console.error('rewardsForm', error);
      }
      this.$router.push({
        name: 'rewards',
        params: {
          markComplete: true,
        },
      });
    },
  },
  watch: {
    async rewardsSelected(newRewardsSelected, oldRewardsSelected) {
      newRewardsSelected.length ? (this.showSaveButton = true) : (this.showSaveButton = false);
    },
  },
};
</script>

<style lang="scss" scoped>
.rewardCard {
  min-width: 160px;
  max-width: 260px;
  flex-grow: 1;
  transition: 200ms;
  &:hover {
    background-color: rgba(224, 224, 224, 0.5);
    cursor: pointer;
    transform: scale(1.05);
  }
}
</style>
